<div
  class="col-12 px-3 mt-3"
  sizeForm
  [group]="group"
  [ngClass]="{
    'd-none':
      group.name === 'care level' && section.formReference === 'memory_care'
  }">
  <div
    class="row align-items-center"
    *ngIf="
      group.name !== 'religion spiritual' &&
      group.label !== section.label &&
      group.name !== 'people who are important to me' &&
      group.name !== 'other details' &&
      group.name !== 'relative'
    ">
    <div class="col-9">
      <h6 class="m-0">
        {{ group.label }}
      </h6>
    </div>
    <div class="col-3 text-end"></div>
  </div>

  <div>
    <ng-container appForms></ng-container>
  </div>
</div>
